import { render, staticRenderFns } from "./DiagnosticImageFilter.vue?vue&type=template&id=2d4f86d6"
import script from "./DiagnosticImageFilter.vue?vue&type=script&lang=js"
export * from "./DiagnosticImageFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports